import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import MeetTheTeam from './pages/MeetTheTeam';
import PublicSpeaking from './pages/PublicSpeaking';
import WhatWeValue from './pages/WhatWeValue';
import ContactUs from './pages/ContactUs';
import OurVision from './pages/OurVision';
import Blogs from './pages/blog/Blogs';
import WebDesign from './pages/WebDesign';
import DigitalMarketing from './pages/DigitalMarketing';
import Services from './pages/Services';
import NotFound from './pages/NotFound';
import RisingStar from './pages/blog/RisingStar';
import Marketing5Signs from './pages/blog/Marketing5Signs';
import Festival from './pages/blog/Festival';
import BoostProductivity from './pages/blog/BoostProductivity';
import Barbie from './pages/blog/Barbie';
import MetaAI from './pages/blog/MetaAI';
import PublicSpeakingSkills from './pages/blog/PublicSpeakingSkills';
import Hashtags from './pages/blog/Hashtags';
import NetworkingEnterprise from './pages/blog/NetworkingEnterprise';
import LinkedIN from './pages/blog/LinkedIN';
import PowerSpokenWord from './pages/blog/PowerSpokenWord';
import DigitalFrontier from './pages/blog/DigitalFrontier';
import ScrollToTop from './components/ScrollToTop';
import PageTransition from './components/PageTransition';
import { BLOG_ENABLED } from './config/blogConfig';
import { useScrollReveal } from './hooks/useScrollReveal';
import './styles/animations.css';
import { ALL_IMAGES } from './config/imagePaths';

function BlogRedirect() {
  return <Navigate to="/" replace />;
}

function AppRoutes() {
  useScrollReveal();

  const blogRoutes = BLOG_ENABLED ? (
    <>
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/rising-star" element={<RisingStar />} />
      <Route path="/marketing-5-signs" element={<Marketing5Signs />} />
      <Route path="/festival" element={<Festival />} />
      <Route path="/boost-productivity" element={<BoostProductivity />} />
      <Route path="/barbie" element={<Barbie />} />
      <Route path="/meta-ai" element={<MetaAI />} />
      <Route path="/public-speaking-skills" element={<PublicSpeakingSkills />} />
      <Route path="/hashtags" element={<Hashtags />} />
      <Route path="/networking-enterprise" element={<NetworkingEnterprise />} />
      <Route path="/linked-in" element={<LinkedIN />} />
      <Route path="/power-spoken-word" element={<PowerSpokenWord />} />
      <Route path="/digital-frontier" element={<DigitalFrontier />} />
    </>
  ) : (
    <>
      <Route path="/blogs" element={<BlogRedirect />} />
      <Route path="/rising-star" element={<BlogRedirect />} />
      <Route path="/marketing-5-signs" element={<BlogRedirect />} />
      <Route path="/festival" element={<BlogRedirect />} />
      <Route path="/boost-productivity" element={<BlogRedirect />} />
      <Route path="/barbie" element={<BlogRedirect />} />
      <Route path="/meta-ai" element={<BlogRedirect />} />
      <Route path="/public-speaking-skills" element={<BlogRedirect />} />
      <Route path="/hashtags" element={<BlogRedirect />} />
      <Route path="/networking-enterprise" element={<BlogRedirect />} />
      <Route path="/linked-in" element={<BlogRedirect />} />
      <Route path="/power-spoken-word" element={<BlogRedirect />} />
      <Route path="/digital-frontier" element={<BlogRedirect />} />
    </>
  );

  return (
    <PageTransition>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/meet-the-team" element={<MeetTheTeam />} />
      <Route path="/public-speaking" element={<PublicSpeaking />} />
      <Route path="/what-we-value" element={<WhatWeValue />} />
      <Route path="/our-vision" element={<OurVision />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/web-design" element={<WebDesign />} />
      <Route path="/services" element={<Services />} />
      <Route path="/digital-marketing" element={<DigitalMarketing />} />
      {blogRoutes}
      <Route path="*" element={<NotFound />} />
    </PageTransition>
  );
}

function App() {
  useEffect(() => {
    ALL_IMAGES.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
